// extracted by mini-css-extract-plugin
module.exports = {"customInput":"NiceInput_customInput__2AnZd"};